export class RegisterFormType {
  babyName?: string;
  babyBirthday?: string;
  email?: string;
  password?: string;

  constructor(init?: Partial<RegisterFormType>) {
    Object.assign(this, init);
  }
}
